import React from 'react';
import * as styles from '@/css/smallcon.module.css';

const MarqueeContent = () => (
  <div className="relative flex items-center mx-2" role="presentation">
    <svg
      width="44"
      height="32"
      viewBox="0 0 44 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g filter="url(#filter0_dddd_2413_22010)">
        <rect x="6" width="32" height="32" rx="4" fill="white" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9C16 8.44772 16.4477 8 17 8C17.5523 8 18 8.44772 18 9C18 9.55228 17.5523 10 17 10C16.4477 10 16 9.55228 16 9ZM18 11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11C14 11.5523 14.4477 12 15 12C14.4477 12 14 12.4477 14 13C14 12.4477 13.5523 12 13 12C12.4477 12 12 12.4477 12 13C12 13.5523 12.4477 14 13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16C12.4477 16 12 16.4477 12 17C12 17.5523 12.4477 18 13 18C13.5523 18 14 17.5523 14 17C14 17.5523 14.4477 18 15 18C14.4477 18 14 18.4477 14 19C14 19.5523 14.4477 20 15 20C15.5523 20 16 19.5523 16 19C16 19.5523 16.4477 20 17 20C16.4477 20 16 20.4477 16 21C16 21.5523 16.4477 22 17 22C17.5523 22 18 21.5523 18 21C18 21.5523 18.4477 22 19 22C18.4477 22 18 22.4477 18 23C18 23.5523 18.4477 24 19 24C19.5523 24 20 23.5523 20 23C20 23.5523 20.4477 24 21 24C20.4477 24 20 24.4477 20 25C20 25.5523 20.4477 26 21 26C21.5523 26 22 25.5523 22 25C22 25.5523 22.4477 26 23 26C23.5523 26 24 25.5523 24 25C24 24.4477 23.5523 24 23 24C23.5523 24 24 23.5523 24 23C24 23.5523 24.4477 24 25 24C25.5523 24 26 23.5523 26 23C26 22.4477 25.5523 22 25 22C25.5523 22 26 21.5523 26 21C26 21.5523 26.4477 22 27 22C27.5523 22 28 21.5523 28 21C28 20.4477 27.5523 20 27 20C27.5523 20 28 19.5523 28 19C28 19.5523 28.4477 20 29 20C29.5523 20 30 19.5523 30 19C30 18.4477 29.5523 18 29 18C29.5523 18 30 17.5523 30 17C30 17.5523 30.4477 18 31 18C31.5523 18 32 17.5523 32 17C32 16.4477 31.5523 16 31 16C31.5523 16 32 15.5523 32 15C32 14.4477 31.5523 14 31 14C31.5523 14 32 13.5523 32 13C32 12.4477 31.5523 12 31 12C30.4477 12 30 12.4477 30 13C30 12.4477 29.5523 12 29 12C29.5523 12 30 11.5523 30 11C30 10.4477 29.5523 10 29 10C28.4477 10 28 10.4477 28 11C28 10.4477 27.5523 10 27 10C27.5523 10 28 9.55228 28 9C28 8.44772 27.5523 8 27 8C26.4477 8 26 8.44772 26 9C26 8.44772 25.5523 8 25 8C24.4477 8 24 8.44772 24 9C24 9.55228 24.4477 10 25 10C24.4477 10 24 10.4477 24 11C24 10.4477 23.5523 10 23 10C22.4477 10 22 10.4477 22 11C22 10.4477 21.5523 10 21 10C20.4477 10 20 10.4477 20 11C20 10.4477 19.5523 10 19 10C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8C18.4477 8 18 8.44772 18 9C18 9.55228 18.4477 10 19 10C18.4477 10 18 10.4477 18 11ZM19 12C19.5523 12 20 11.5523 20 11C20 11.5523 20.4477 12 21 12C20.4477 12 20 12.4477 20 13C20 12.4477 19.5523 12 19 12ZM18 13C18 12.4477 18.4477 12 19 12C18.4477 12 18 11.5523 18 11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11C16 11.5523 15.5523 12 15 12C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14C14.4477 14 14 13.5523 14 13C14 13.5523 13.5523 14 13 14C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16C13.5523 16 14 16.4477 14 17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18C15.5523 18 16 18.4477 16 19C16 18.4477 16.4477 18 17 18C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20C17.5523 20 18 20.4477 18 21C18 20.4477 18.4477 20 19 20C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22C19.5523 22 20 22.4477 20 23C20 22.4477 20.4477 22 21 22C21.5523 22 22 22.4477 22 23C22 23.5523 21.5523 24 21 24C21.5523 24 22 24.4477 22 25C22 24.4477 22.4477 24 23 24C22.4477 24 22 23.5523 22 23C22 22.4477 22.4477 22 23 22C23.5523 22 24 22.4477 24 23C24 22.4477 24.4477 22 25 22C24.4477 22 24 21.5523 24 21C24 20.4477 24.4477 20 25 20C25.5523 20 26 20.4477 26 21C26 20.4477 26.4477 20 27 20C26.4477 20 26 19.5523 26 19C26 18.4477 26.4477 18 27 18C27.5523 18 28 18.4477 28 19C28 18.4477 28.4477 18 29 18C28.4477 18 28 17.5523 28 17C28 16.4477 28.4477 16 29 16C29.5523 16 30 16.4477 30 17C30 16.4477 30.4477 16 31 16C30.4477 16 30 15.5523 30 15C30 14.4477 30.4477 14 31 14C30.4477 14 30 13.5523 30 13C30 13.5523 29.5523 14 29 14C28.4477 14 28 13.5523 28 13C28 12.4477 28.4477 12 29 12C28.4477 12 28 11.5523 28 11C28 11.5523 27.5523 12 27 12C26.4477 12 26 11.5523 26 11C26 10.4477 26.4477 10 27 10C26.4477 10 26 9.55228 26 9C26 9.55228 25.5523 10 25 10C25.5523 10 26 10.4477 26 11C26 11.5523 25.5523 12 25 12C24.4477 12 24 11.5523 24 11C24 11.5523 23.5523 12 23 12C22.4477 12 22 11.5523 22 11C22 11.5523 21.5523 12 21 12C21.5523 12 22 12.4477 22 13C22 13.5523 21.5523 14 21 14C20.4477 14 20 13.5523 20 13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13ZM17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14ZM18 15C18 14.4477 18.4477 14 19 14C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16C18.4477 16 18 15.5523 18 15ZM17 16C17.5523 16 18 15.5523 18 15C18 14.4477 17.5523 14 17 14C16.4477 14 16 14.4477 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15C16 15.5523 16.4477 16 17 16ZM18 17C18 16.4477 18.4477 16 19 16C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18C18.4477 18 18 17.5523 18 17ZM20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19ZM21 18C20.4477 18 20 17.5523 20 17C20 16.4477 20.4477 16 21 16C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18ZM22 19C22 18.4477 21.5523 18 21 18C20.4477 18 20 18.4477 20 19C20 19.5523 20.4477 20 21 20C20.4477 20 20 20.4477 20 21C20 21.5523 20.4477 22 21 22C21.5523 22 22 21.5523 22 21C22 21.5523 22.4477 22 23 22C23.5523 22 24 21.5523 24 21C24 20.4477 23.5523 20 23 20C23.5523 20 24 19.5523 24 19C24 19.5523 24.4477 20 25 20C25.5523 20 26 19.5523 26 19C26 18.4477 25.5523 18 25 18C25.5523 18 26 17.5523 26 17C26 17.5523 26.4477 18 27 18C27.5523 18 28 17.5523 28 17C28 16.4477 27.5523 16 27 16C27.5523 16 28 15.5523 28 15C28 15.5523 28.4477 16 29 16C29.5523 16 30 15.5523 30 15C30 14.4477 29.5523 14 29 14C28.4477 14 28 14.4477 28 15C28 14.4477 27.5523 14 27 14C27.5523 14 28 13.5523 28 13C28 12.4477 27.5523 12 27 12C26.4477 12 26 12.4477 26 13C26 12.4477 25.5523 12 25 12C24.4477 12 24 12.4477 24 13C24 12.4477 23.5523 12 23 12C22.4477 12 22 12.4477 22 13C22 13.5523 22.4477 14 23 14C22.4477 14 22 14.4477 22 15C22 14.4477 21.5523 14 21 14C20.4477 14 20 14.4477 20 15C20 15.5523 20.4477 16 21 16C21.5523 16 22 15.5523 22 15C22 15.5523 22.4477 16 23 16C22.4477 16 22 16.4477 22 17C22 17.5523 22.4477 18 23 18C22.4477 18 22 18.4477 22 19ZM24 17C24 17.5523 24.4477 18 25 18C24.4477 18 24 18.4477 24 19C24 18.4477 23.5523 18 23 18C23.5523 18 24 17.5523 24 17ZM25 16C25.5523 16 26 16.4477 26 17C26 16.4477 26.4477 16 27 16C26.4477 16 26 15.5523 26 15C26 14.4477 26.4477 14 27 14C26.4477 14 26 13.5523 26 13C26 13.5523 25.5523 14 25 14C24.4477 14 24 13.5523 24 13C24 13.5523 23.5523 14 23 14C23.5523 14 24 14.4477 24 15C24 15.5523 23.5523 16 23 16C23.5523 16 24 16.4477 24 17C24 16.4477 24.4477 16 25 16ZM25 16C24.4477 16 24 15.5523 24 15C24 14.4477 24.4477 14 25 14C25.5523 14 26 14.4477 26 15C26 15.5523 25.5523 16 25 16ZM22 19C22 19.5523 22.4477 20 23 20C22.4477 20 22 20.4477 22 21C22 20.4477 21.5523 20 21 20C21.5523 20 22 19.5523 22 19ZM18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17Z"
        fill="#FF622B"
      />
      <defs>
        <filter
          id="filter0_dddd_2413_22010"
          x="0"
          y="-1"
          width="44"
          height="54"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2413_22010"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_2413_22010"
            result="effect2_dropShadow_2413_22010"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_2413_22010"
            result="effect3_dropShadow_2413_22010"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="15" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_2413_22010"
            result="effect4_dropShadow_2413_22010"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect4_dropShadow_2413_22010"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
    <span className="ms-4 uppercase text-orange text-xl" aria-hidden="true">
      Most powerful way to train. Fastest way to serve. Smartest way to scale.
    </span>
  </div>
);

export const Marquee = ({ padding }) => {
  return (
    <div className={`relative px-0 overflow-hidden ${padding}`}>
      <div className="w-full overflow-hidden border-t border-b border-[#F4F4F4]">
        <div className="bg-[repeating-linear-gradient(-45deg,transparent,transparent_3px,#EEEEEE_0,#EEEEEE_4px)] w-full h-12" />
      </div>
      <div className="relative w-full py-1 bg-white overflow-x-hidden">
        <div className="relative flex whitespace-nowrap overflow-x-hidden">
          <h2 className="sr-only">Predibase Platform Benefits: Most powerful way to train. Fastest way to serve. Smartest way to scale.</h2>
          {/* First sliding container */}
          <div className={`${styles.animatemarquee} flex items-center`} role="presentation">
            {Array.from({ length: 10 }).map((_, index) => (
              <MarqueeContent key={index} />
            ))}
          </div>

          {/* Duplicate container for seamless loop */}
          <div
            className={`${styles.animatemarquee2} flex items-center absolute top-0`}
            role="presentation"
          >
            {Array.from({ length: 10 }).map((_, index) => (
              <MarqueeContent key={`duplicate-${index}`} />
            ))}
          </div>
        </div>
      </div>
      <div className="w-full overflow-hidden border-t border-b border-[#F4F4F4]">
        <div className="bg-[repeating-linear-gradient(-45deg,transparent,transparent_3px,#EEEEEE_0,#EEEEEE_4px)] w-full h-12" />
      </div>
    </div>
  );
};
